import React from 'react';
import AdminDashboard from './adminDashboard/AdminDashboard';
import CertificationDashboard from './certificationDashboard/CertificationDashboard';
import SponsorDashboard from './sponsorDashboard/SponsorDashboard';
import * as App from 'modules/app/App'

class Dashboard extends React.Component {

	initialState = (props) => {
		return {
			certificationKey: null,
			certificationStepCode: null,
			inProgressCertifications: [],
			preQualifyCertifications: [],
			payedPreQualifyCertifications: [],
			finishedCertifications: []
		};
	}

	render() {
		let userTypeCode = App.context().userTypeCode;
		let dashboard;

		if (userTypeCode === 'CER')
			dashboard = <CertificationDashboard />;
		else if (userTypeCode === 'ADM')
			dashboard = <AdminDashboard />;
		else if (userTypeCode === 'SPN')
			dashboard = <SponsorDashboard />;

		return (
			<React.Fragment>
				{dashboard}
			</React.Fragment >
		)
	}
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/Dashboard.js